import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import { isIsoTime } from '../validation/is-iso-time.function';
import { isIsoTimeTz } from '../validation/is-iso-time-tz.function';
import type { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the seconds (0-59) from an ISO 8601 date-time or time string.
 *
 * Supported inputs:
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 * - Time-only (no tz): HH:mm:ss(.fraction[1-6])?
 * - Time-only with tz: HH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Returns the numeric seconds (0-59).
 * Throws if the input is not a valid ISO time/date-time in one of the above forms.
 */
export function getSecond(input: IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz): number {
  const { seconds } = deconstructDate(input);
  if (seconds === undefined) {
    throw new Error('getSecond: invalid ISO time/date-time string');
  }
  return seconds;
}

